module.exports = __webpack_public_path__ + "static/media/8.baee4e01.jpg";